/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "Cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('Cart:refresh', {
 *   bubbles: true
 * }));
 */

let theme = window.theme || {};
var $page = [...document.querySelector("body").classList];

window.isPage = (id) => {
  return $page.includes(id);
};

window.getPageType = (id) => {
  const $page = window.location.pathname;
  if ($page.includes("/products")) {
    return "product_page";
  } else if ($page.includes("/collections")) {
    return "collection_page";
  } else if ($page.includes("/blogs")) {
    return "blog";
  } else if ($page === "/") {
    return "homepage";
  } else {
    return "not_set";
  }
  return "not_set";
};
window.docReady = function (callback) {
  var readyState = document.readyState;
  if (readyState == "complete" || readyState == "interactive") {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout(callback);
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
};
window.isInViewport = function (el) {
  const rect = el.getBoundingClientRect();
  const elementVisibility = window.getComputedStyle(el).visibility;
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    el.offsetParent !== null &&
    elementVisibility !== "hidden"
  );
};
window.getObjectProp = function (obj, propString) {
  if (!propString) return obj;

  var prop,
    props = propString.split(".");

  for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
    prop = props[i];

    var candidate = obj[prop];
    if (candidate !== undefined) {
      obj = candidate;
    } else {
      break;
    }
  }
  return obj[props[i]];
};

class SimpleCore {
  constructor() {
    const $this = this;
    this._helpers = {
      getUtmParams: () => {
        const params = new URLSearchParams(window.location.search);
        let utmParams = null;

        if (params && params.size) {
          utmParams = {};
          for (const [key, val] of params) {
            // check for prefix
            if (key.startsWith("utm_")) {
              // add to a new object array
              utmParams[key] = val;
            }
          }
        }
        return utmParams;
      },
      getCookie: (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
      },
      deleteCookie: (name) => {
        document.cookie =
          name +
          "=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.simpleorganic.com.br";
      },
      setCookie: (
        name,
        value,
        days = 1,
        path = "/",
        domain = window.location.host,
        secure,
      ) => {
        let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
          value,
        )}`;

        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          cookieString += `; expires=${date.toUTCString()}`;
        }

        if (path) {
          cookieString += `; path=${path}`;
        }

        if (domain) {
          cookieString += `; domain=.${domain}`;
        }

        if (secure) {
          cookieString += `; secure`;
        }

        document.cookie = cookieString;
      },
      checkVariable: (variableName, interval = 500) => {
        return new Promise((resolve, reject) => {
          const checkInterval = setInterval(() => {
            if (window[variableName] !== undefined) {
              clearInterval(checkInterval);
              resolve(true); // Variable found
            }
          }, interval);

          // Set a timeout to stop the check after a certain period
          setTimeout(() => {
            clearInterval(checkInterval);
            resolve(false); // Variable not found within the timeout
          }, 10000); // You can adjust the timeout duration as needed
        });
      },
      checkPropertyType: (prop) => {
        if (!prop) {
          return null;
        }
        if (Array.isArray(prop)) {
          return "array";
        } else {
          return typeof prop;
        }
      },
      getUniqueArray(arr) {
        return [...new Set(arr)];
      },
      sleep: (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      formatMoney: (cents, format = "R$ {{amount_with_comma_separator}}") => {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || window.themeVariables.settings.moneyFormat;
        function defaultTo(value2, defaultValue) {
          return value2 == null || value2 !== value2 ? defaultValue : value2;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ",");
          decimal = defaultTo(decimal, ".");
          if (isNaN(number) || number == null) {
            return 0;
          }
          number = (number / 100).toFixed(precision);
          let parts = number.split("."),
            dollarsAmount = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands,
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
          return dollarsAmount + centsAmount;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
          return formatString.replace(placeholderRegex, value);
        } else {
          return formatString.replace(placeholderRegex, value);
        }
      },
      scrollTo: ($selector, offset = 0) => {
        window.scrollTo({
          top: $selector.offsetTop + offset,
          behavior: "smooth",
        });
      },
      triggerEvent: (name, payload, element) => {
        var event = new CustomEvent(`so.${name}`, {
          bubbles: true,
          detail: payload ? payload : null,
        });
        if (element) {
          return element.dispatchEvent(event);
        }
        document.dispatchEvent(event);
      },
      groupBy: (obj_array, prop) => {
        if (!obj_array) {
          throw new Error("Object is required");
        }
        if (!prop) {
          return obj_array;
        }
        return obj_array.reduce(function (r, a) {
          let $key = a[prop];
          r[$key] = r[$key] || [];
          r[$key].push(a);
          return r;
        }, Object.create(null));
      },
      docReady: function (callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
          // do async to allow for other scripts to run. metafizzy/flickity#441
          setTimeout(callback);
        } else {
          document.addEventListener("DOMContentLoaded", callback);
        }
      },
      validateEmail: function (email) {
        const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "gm");
        const isValidEmail = emailRegex.test(email);
        return isValidEmail;
      },
      getCustomerData: (prop) => {
        let data_source = window.SimpleCore._session.currentSession;
        return window.getObjectProp(data_source, prop);
      },
      generateUUID: () => {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          },
        );
      },
    };
    this.customer_auth = {
      API: null,
      APIService: {
        auth: async function () {
          if (!this.API) {
            return console.error("this.API is required");
          }
          if (!window.EvolveHUB._c) {
            return console.error("window.EvolveHUB._c is required");
          }
          let _c = atob(window.EvolveHUB._c);
          let cd = _c.split(":");
          let authResponse = await this.API.post(`/AuthApi/Authorize`, {
            apiKey: cd[0],
            password: cd[1],
          });
          if (authResponse && authResponse.data) {
            let accessToken = authResponse.data.data.accessToken;
            sessionStorage.setItem("cAuthToken", accessToken);
            return accessToken;
          }
          return console.error("user not authenticated");
          // window.EvolveHUB._c
        },
      },
      _init: async function () {
        let $this = this;
        let storedToken = sessionStorage.getItem("cAuthToken");
        let maximumRetries = 10;

        if ($this.API) {
          return;
        }
        let auth = async function () {
          if (!$this.API) {
            return console.error("$this.API is required");
          }
          if (!window.EvolveHUB._c) {
            return console.error("window.EvolveHUB._c is required");
          }
          let _c = atob(window.EvolveHUB._c);
          let cd = _c.split(":");
          let authResponse = await $this.API.post(`/AuthApi/Authorize`, {
            apiKey: cd[0],
            password: cd[1],
          });
          if (authResponse && authResponse.data) {
            let accessToken = authResponse.data.data.accessToken;
            sessionStorage.setItem("cAuthToken", accessToken);
            return accessToken;
          }
          return console.error("user not authenticated");
          // window.EvolveHUB._c
        };
        let getToken = async function () {
          storedToken = sessionStorage.getItem("cAuthToken");

          if (!storedToken) {
            storedToken = await auth();
          }
          return storedToken;
        };

        this.API = axios.create({
          baseURL: "https://sagefy-external.azurewebsites.net/api",
        });

        this.API.interceptors.request.use(
          async function (config) {
            if (config.url !== "/AuthApi/Authorize") {
              let accessToken = await getToken();
              config.headers.Authorization = `Bearer ${accessToken}`;
            }

            return config;
          },
          function (error) {
            Promise.reject(error);
          },
        );

        this.API.interceptors.response.use(
          (response) => {
            return response;
          },
          async (error) => {
            let originalReq = error.config || {};
            originalReq._retryCount = originalReq._retryCount || 0;
            if (error.code === "ERR_NETWORK") {
              return Promise.reject(error);
            }
            if (
              !sessionStorage.getItem("cAuthToken") &&
              originalReq._retryCount <= maximumRetries
            ) {
              await window.SimpleCore._helpers.sleep(
                1000 * originalReq._retryCount,
              );
              await auth();
            }

            if (
              error.response &&
              (error.response.status === 401 ||
                error.response.status === 500) &&
              originalReq._retryCount <= maximumRetries
            ) {
              try {
                await window.SimpleCore._helpers.sleep(
                  1000 * originalReq._retryCount,
                );
                await auth();
                let response = await this.API.request(originalReq);
                return response;
              } catch (error) {
                throw new Error(error.message);
              }
            }
            originalReq._retryCount++;
            return Promise.reject(error);
          },
        );
        if (!storedToken) {
          auth();
        }
        return;
      },
      getCheckoutUrl() {
        function getParameterByName(name) {
          name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
          var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
          return results === null
            ? ""
            : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        return getParameterByName("checkout_url");
      },
      sign_in_newsletter_rdstation: async function (email) {
        try {
          if (!email) {
            throw { name: "field_required", message: "Email é obrigatório" };
          }

          var data = {
            client_tracking_id: "",
            conversion_url: window.location.href,
            conversion_domain: window.location.host,
            conversion_identifier: "formulario-newsletter-popup",
            internal_source: "6",
            c_utmz: "",
            traffic_source: "",
            _doe: "",
            privacy_data: { browser: "" },
            email: email,
            "": "",
            emP7yF13ld: "",
            sh0uldN07ch4ng3: "should_not_change",
            redirect_to: "http://simpleorganic.com.br",
          };

          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post(
            "https://cta-redirect.rdstation.com/v2/conversions",
            data,
            {
              headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: "PublicToken bf56cce38ba433807c5251f0ae605ab0",
              },
              maxRedirects: 0,
            },
          );
          var newsletterPayload = response.data;
          if (newsletterPayload) {
            return true;
          }
          throw {
            name: "customer_sign_newsletter:error",
            message: "Erro ao cadastrar em newsletter",
            customer: email,
          };
        } catch ({ name, message, customer }) {
          throw { name, message, customer };
        }
      },
      sign_in_newsletter: async function (email) {
        try {
          if (!email) {
            throw { name: "field_required", message: "Email é obrigatório" };
          }

          var data = {
            "contact[email]": email,
            "contact[tags]": "newsletter, popup",
            form_type: "customer",
            utf8: "✓",
            xpto: "xxx",
          };
          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post("/contact", Qs.stringify(data), {
            headers: {
              "content-type":
                "application/x-www-form-urlencoded; charset=utf-8",
              accept: "text/html, */*; q=0.01",
              "x-requested-with": "XMLHttpRequest",
            },
            maxRedirects: 0,
          });
          var newsletterPayload = response.data;

          // if (newsletterPayload.indexOf("[ERR: INVALID_CREDENTIALS]") !== -1) {
          //   let customerDetails = await SimpleCore.customer_auth.status(email);
          //   if (customerDetails.status === "disabled") {
          //     throw {
          //       name: "customer_without_password",
          //       message: "O e-mail digitado não possui senha cadastrada",
          //       customer: customerDetails,
          //     };
          //   } else if (customerDetails.status === "enabled") {
          //     throw {
          //       name: "wrong_credentials",
          //       message: "Senha incorreta",
          //       customer: customerDetails,
          //     };
          //   } else if (customerDetails.status === "not_found") {
          //     throw {
          //       name: "customer_not_found",
          //       message: "E-mail não cadastrado",
          //       customer: customerDetails,
          //     };
          //   }
          // } else {
          //   var checkoutUrl = SimpleCore.customer_auth.getCheckoutUrl();
          //   var redirect_url = checkoutUrl ? checkoutUrl : "/account";
          //   return {
          //     status: "success",
          //     redirect_url: redirect_url,
          //   };
          // }
        } catch ({ name, message, customer }) {
          throw { name, message, customer };
        }
      },
      login: async function (email, password) {
        try {
          if (!email) {
            throw { name: "field_required", message: "Email é obrigatório" };
          }
          if (!password) {
            throw { name: "field_required", message: "Senha é obrigatória" };
          }

          var data = {
            "customer[email]": email,
            "customer[password]": password,
            form_type: "customer_login",
            utf8: "✓",
            xpto: "xxx",
          };
          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post(
            "/account/login",
            Qs.stringify(data),
            {
              headers: {
                "content-type":
                  "application/x-www-form-urlencoded; charset=utf-8",
                accept: "text/html, */*; q=0.01",
                "x-requested-with": "XMLHttpRequest",
              },
              maxRedirects: 0,
            },
          );
          var loginPayload = response.data;
          if (loginPayload.indexOf("[ERR: INVALID_CREDENTIALS]") !== -1) {
            let customerDetails = await SimpleCore.customer_auth.status(email);
            if (customerDetails.status === "disabled") {
              throw {
                name: "customer_without_password",
                message: "O e-mail digitado não possui senha cadastrada",
                customer: customerDetails,
              };
            } else if (customerDetails.status === "enabled") {
              throw {
                name: "wrong_credentials",
                message: "Senha incorreta",
                customer: customerDetails,
              };
            } else if (customerDetails.status === "not_found") {
              throw {
                name: "customer_not_found",
                message: "E-mail não cadastrado",
                customer: customerDetails,
              };
            }
          } else {
            var checkoutUrl = SimpleCore.customer_auth.getCheckoutUrl();
            var redirect_url = checkoutUrl ? checkoutUrl : "/account";
            return {
              status: "success",
              redirect_url: redirect_url,
            };
          }
        } catch ({ name, message, customer }) {
          throw { name, message, customer };
        }
      },
      recover_password: async function (email) {
        try {
          if (!email) {
            throw { name: "field_required", message: "Email é obrigatório" };
          }

          var data = {
            email: email,
            form_type: "recover_customer_password",
            utf8: "✓",
            xpto: "xxx",
          };
          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post(
            "/account/recover",
            Qs.stringify(data),
            {
              headers: {
                "content-type":
                  "application/x-www-form-urlencoded; charset=utf-8",
                accept: "text/html, */*; q=0.01",
                "x-requested-with": "XMLHttpRequest",
              },
              maxRedirects: 0,
            },
          );
          var recoveryPasswordPayload = response.data;
          if (
            recoveryPasswordPayload.indexOf("[ERR: INVALID_CREDENTIALS]") !== -1
          ) {
            throw {
              name: "customer_not_found",
              message: "E-mail não cadastrado",
            };
          } else {
            var checkoutUrl = SimpleCore.customer_auth.getCheckoutUrl();
            var redirect_url = checkoutUrl ? checkoutUrl : "/account/login";
            return {
              status: "success",
              redirect_url: redirect_url,
            };
          }
        } catch ({ name, message, customer }) {
          throw { name, message, customer };
        }
      },
      activate_account: async function (
        id,
        token,
        password,
        password_confirmation,
      ) {
        try {
          if (!id) {
            throw { name: "field_required", message: "ID é obrigatório" };
          }
          if (!token) {
            throw { name: "field_required", message: "Token é obrigatório" };
          }
          if (!password) {
            throw { name: "field_required", message: "Senha é obrigatória" };
          }
          if (!password_confirmation) {
            throw {
              name: "field_required",
              message: "Confirmação de senha é obrigatório",
            };
          }
          if (password !== password_confirmation) {
            throw {
              name: "password_not_matching",
              message: "As senhas precisam ser iguais",
            };
          }

          var data = {
            id: id,
            token: token,
            "customer[password]": password,
            "customer[password_confirmation]": password_confirmation,
            form_type: "activate_customer_password",
            utf8: "✓",
            xpto: "xxx",
          };
          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post(
            "/account/activate",
            Qs.stringify(data),
            {
              headers: {
                "content-type":
                  "application/x-www-form-urlencoded; charset=utf-8",
                accept: "text/html, */*; q=0.01",
                "x-requested-with": "XMLHttpRequest",
              },
              maxRedirects: 0,
            },
          );
          var recoveryPasswordPayload = response.data;
          if (
            recoveryPasswordPayload.indexOf("Erro ao confirmar a senha") !== -1
          ) {
            throw {
              name: "customer_activate_account_error",
              message: "Erro ao confirmar a senha",
            };
          } else {
            var checkoutUrl = SimpleCore.customer_auth.getCheckoutUrl();
            var redirect_url = checkoutUrl ? checkoutUrl : "/account/";
            return {
              status: "success",
              redirect_url: redirect_url,
            };
          }
        } catch ({ name, message, customer }) {
          if (message.includes("404")) {
            throw {
              name: "customer_activate_account_token_expired",
              message:
                "Link de redefinição expirado, por favor tente novamente",
            };
          }
          throw { name, message, customer };
        }
      },
      reset_password: async function (
        id,
        token,
        password,
        password_confirmation,
      ) {
        try {
          if (!id) {
            throw { name: "field_required", message: "ID é obrigatório" };
          }
          if (!token) {
            throw { name: "field_required", message: "Token é obrigatório" };
          }
          if (!password) {
            throw { name: "field_required", message: "Senha é obrigatória" };
          }
          if (!password_confirmation) {
            throw {
              name: "field_required",
              message: "Confirmação de senha é obrigatório",
            };
          }
          if (password !== password_confirmation) {
            throw {
              name: "password_not_matching",
              message: "As senhas precisam ser iguais",
            };
          }

          var data = {
            id: id,
            token: token,
            "customer[password]": password,
            "customer[password_confirmation]": password_confirmation,
            form_type: "reset_customer_password",
            utf8: "✓",
            xpto: "xxx",
          };
          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post(
            "/account/reset",
            Qs.stringify(data),
            {
              headers: {
                "content-type":
                  "application/x-www-form-urlencoded; charset=utf-8",
                accept: "text/html, */*; q=0.01",
                "x-requested-with": "XMLHttpRequest",
              },
              maxRedirects: 0,
            },
          );
          var recoveryPasswordPayload = response.data;
          if (
            recoveryPasswordPayload.indexOf("Erro ao redefinir a senha") !== -1
          ) {
            throw {
              name: "customer_password_reset_error",
              message: "Erro ao redefinir a senha",
            };
          } else {
            var checkoutUrl = SimpleCore.customer_auth.getCheckoutUrl();
            var redirect_url = checkoutUrl ? checkoutUrl : "/account/";
            return {
              status: "success",
              redirect_url: redirect_url,
            };
          }
        } catch ({ name, message, customer }) {
          if (message.includes("404")) {
            throw {
              name: "customer_password_reset_token_expired",
              message:
                "Link de redefinição expirado, por favor tente novamente",
            };
          }
          throw { name, message, customer };
        }
      },
      register: async function (firstName, lastName, email, password) {
        try {
          if (!firstName) {
            throw { name: "field_required", message: "Nome é obrigatório" };
          }
          if (!lastName) {
            throw {
              name: "field_required",
              message: "Sobrenome é obrigatório",
            };
          }
          if (!email) {
            throw { name: "field_required", message: "Email é obrigatório" };
          }
          if (!password) {
            throw { name: "field_required", message: "Senha é obrigatória" };
          }
          //Implantar classe de Validaçoes de Email, senha, required
          var data = {
            "customer[email]": email,
            "customer[password]": password,
            "customer[first_name]": firstName,
            "customer[last_name]": lastName,
            form_type: "create_customer",
            utf8: "✓",
            xpto: "xxx",
          };
          axios.interceptors.response.use(
            function (response) {
              return response;
            },
            function (error) {
              // return '[ERR: INVALID_CREDENTIALS]'; //MOCK
              return Promise.reject(error);
            },
          );
          var response = await axios.post("/account", Qs.stringify(data), {
            headers: {
              "content-type":
                "application/x-www-form-urlencoded; charset=utf-8",
              accept: "text/html, */*; q=0.01",
              "x-requested-with": "XMLHttpRequest",
            },
            maxRedirects: 0,
          });
          let registerPayload = response.data;
          // registerPayload = 'E-mail é inválido'; //mock
          if (registerPayload.indexOf("challenge") !== -1) {
            throw { name: "challenge_required", message: "Eu não sou um robô" };
          } else if (registerPayload.indexOf("E-mail é inválido") !== -1) {
            throw { name: "invalid_email", message: "E-mail inválido" };
          } else if (
            registerPayload.indexOf("email can&#39;t be blank") !== -1
          ) {
            throw {
              name: "blank_email",
              message: "Seu e-mail não pode ficar em branco",
            };
          } else if (
            registerPayload.indexOf("password can&#39;t be blank.") !== -1
          ) {
            throw {
              name: "blank_password",
              message: "Sua senha não pode ficar em branco",
            };
          } else {
            var checkoutUrl = SimpleCore.customer_auth.getCheckoutUrl();
            var redirect_url = checkoutUrl ? checkoutUrl : "/account";
            return {
              status: "success",
              redirect_url: redirect_url,
            };
          }
        } catch ({ name, message }) {
          throw { name, message };
        }
      },

      status: async function (email) {
        try {
          if (!email) {
            throw new Error("Email is required");
          }
          let customerStatusOBJ = await this.API.get(`/Customer/${email}`);
          let customerOBJ = {
            id: customerStatusOBJ.data.eCommerceId,
            email: customerStatusOBJ.data.email,
            status: customerStatusOBJ.data.status,
          };
          if (!customerOBJ.email.toLowerCase() === email.toLowerCase()) {
            throw new Error("Emails not matching");
          }
          return customerOBJ;
        } catch (e) {
          if (
            e.response &&
            (e.response.status === 404 || e.response.status === 400)
          ) {
            return { status: "not_found" };
          }
          console.error(e.message);
        }
      },
      send_activation_invite: async function (customer_id) {
        try {
          if (!customer_id) {
            return new Error("Customer ID is required");
          }
          let customerStatusOBJ = await this.API.post(
            `/Customer/${customer_id}/SendActivation`,
            {},
          );
          return customerStatusOBJ.data;
        } catch ({ name, message }) {
          throw { name, message };
        }
      },
    };
    this._session = {
      prefix: "so._s",
      _c: window._simplecore.customer,
      currentSession: {},
      getCurrent: () => {
        let currentSession = localStorage.getItem(this._session.prefix);

        currentSession = JSON.parse(currentSession);
        this._session.currentSession = currentSession; // Update currentSession
        return currentSession;
      },
      update: (prop, value) => {
        if (!prop || !value) {
          return console.error("Fields prop and value are required");
        }
        switch (
          this._helpers.checkPropertyType(this._session.currentSession[prop])
        ) {
          case "array":
            this._session.currentSession[prop] = this._helpers.getUniqueArray(
              this._session.currentSession[prop].concat(value), // Use concat to create a new array
            );
            break;
          default:
            this._session.currentSession[prop] = value;
            break;
        }
        localStorage.setItem(
          this._session.prefix,
          JSON.stringify(this._session.currentSession),
        );
      },
      create: async () => {
        let _sessionObj = {
          _id: this._helpers.generateUUID(),
          last_seen_products: [],
          liked_products: [],
        };

        let localSession = localStorage.getItem(this._session.prefix)
          ? JSON.parse(localStorage.getItem(this._session.prefix))
          : _sessionObj;

        let customerData =
          this._session._c && this._session._c.details
            ? this._session._c.details
            : null;

        let _s = {
          _id: localSession._id,
          last_seen_products: [
            ...new Set([
              ...(customerData?.last_seen_products || []),
              ...(localSession?.last_seen_products || []),
            ]),
          ],
          liked_products: [
            ...new Set([
              ...(customerData?.liked_products || []),
              ...(localSession?.liked_products || []),
            ]),
          ],
          skin_needs: [
            ...new Set([
              ...(customerData?.skin_needs || []),
              ...(localSession?.skin_needs || []),
            ]),
          ],
          skin_type: customerData?.skin_type,
        };

        localStorage.setItem(this._session.prefix, JSON.stringify(_s));

        return _s;
      },
      init: async () => {
        await this._session.create();
        this._session.getCurrent();
        this._helpers.setCookie("so._sid", this._session.getCurrent()._id, 15);
      },
    };
    this.error_monitoring = {
      init: () => {
        return;
        Sentry.onLoad(function () {
          Sentry.init({
            // Performance Monitoring
            tracesSampleRate: 1.0, // Capture 100% of the transactions
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
          });
        });
      },
    };
    // this.error_monitoring.init();
    this._session.init();
  }
}

// WhatsApp Share Button Functionality
window.SimpleCore = window.SimpleCore || new SimpleCore();
